/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import ActivityDetailContent from '../components/Activity-Detail-Content';
import ActivityDetailLayout from '../components/Activity-Detail-Layout';
import ActivityLayout from '../components/Activity-Layout';
import ActivitySearchResult from '../components/Activity-SearchResult';
import AddtoCalendar from '../components/AddtoCalendar';
import BabyNameLayout from '../components/BabyName-Layout';
import BabyNameSearchResult from '../components/BabyName-SearchResult';
import BabyNameSocialShareResult from '../components/BabyName-SocialShare-Result';
import BabyNameFinderForm from '../components/BabyNameFinderForm';
import ComponentHeader from '../components/ComponentHeader';
import ContentBlock from '../components/ContentBlock';
import CopyRightBlock from '../components/CopyRightBlock';
import DiaperSizeCalculator from '../components/Diaper-Size-Calculator';
import DiaperCalculatorCalculation from '../components/DiaperCalculator-Calculation';
import DiaperCalculatorLayout from '../components/DiaperCalculator-Layout';
import DiaperCalculatorForm from '../components/DiaperCalculatorForm';
import DiaperSizeCalculatorLayout from '../components/DiaperSizeCalculator-Layout';
import DocumentAPI from '../components/Document-API';
import DocumentContentSwagger from '../components/Document-Content-Swagger';
import DueDateCalculator from '../components/DueDate-Calculator';
import DueDateLayout from '../components/DueDate-Layout';
import DueDateSocialShareResult from '../components/DueDate-SocialShare-Result';
import EyeColorLayout from '../components/EyeColor-Layout';
import EyeColorPredictor from '../components/EyeColor-Predictor';
import EyeColorSocialShareResult from '../components/EyeColor-SocialShare-Result';
import FunctionalDocument from '../components/Functional-Document';
import GenderLayout from '../components/Gender-Layout';
import GenderPredictor from '../components/Gender-Predictor';
import GenderSocialShareResult from '../components/Gender-SocialShare-Result';
import GraphQLConnectedDemo from '../components/GraphQL-ConnectedDemo';
import GraphQLIntegratedDemo from '../components/GraphQL-IntegratedDemo';
import GraphQLLayout from '../components/GraphQL-Layout';
import HeaderLogo from '../components/Header-Logo';
import HeightPredictorCalculation from '../components/HeightPredictor-Calculation';
import HeightPredictorLayout from '../components/HeightPredictor-Layout';
import HeightPredictorSocialShareResult from '../components/HeightPredictor-SocialShare-Result';
import Home from '../components/Home';
import HomeComponentData from '../components/HomeComponentData';
import HomeNavigationTile from '../components/HomeNavigationTile';
import Loader from '../components/Loader';
import MainMenu from '../components/MainMenu';
import OvulationCalculator from '../components/Ovulation-Calculator';
import OvulationLayout from '../components/Ovulation-Layout';
import POC from '../components/POC';
import PeriodFeatures from '../components/Period-Features';
import PeriodFeaturesNewVersion from '../components/Period-Features-New-Version';
import PeriodLayout from '../components/Period-Layout';
import PollenTracker from '../components/Pollen-Tracker';
import PollenTrackerLayout from '../components/PollenTracker-Layout';
import ProductIngredientLayout from '../components/ProductIngredient-Layout';
import ProductIngredientData from '../components/ProductIngredientData';
import RecipeDetailContent from '../components/Recipe-Detail-Content';
import RecipeDetailLayout from '../components/Recipe-Detail-Layout';
import RecipeLayout from '../components/Recipe-Layout';
import RecipeSearchResult from '../components/Recipe-SearchResult';
import RecipeDetailCommon from '../components/RecipeDetailCommon';
import RecipeFilterData from '../components/RecipeFilterData';
import RecipeFinderData from '../components/RecipeFinderData';
import SampleSwaggerDoc from '../components/SampleSwaggerDoc';
import SocialShare from '../components/SocialShare';
import WeightGainCalculator from '../components/WeightGain-Calculator';
import WeightGainLayout from '../components/WeightGain-Layout';
import WildcardData from '../components/WildcardData';

const components = new Map();
components.set('Activity-Detail-Content', ActivityDetailContent);
components.set('Activity-Detail-Layout', ActivityDetailLayout);
components.set('Activity-Layout', ActivityLayout);
components.set('Activity-SearchResult', ActivitySearchResult);
components.set('AddtoCalendar', AddtoCalendar);
components.set('BabyName-Layout', BabyNameLayout);
components.set('BabyName-SearchResult', BabyNameSearchResult);
components.set('BabyName-SocialShare-Result', BabyNameSocialShareResult);
components.set('BabyNameFinderForm', BabyNameFinderForm);
components.set('ComponentHeader', ComponentHeader);
components.set('ContentBlock', ContentBlock);
components.set('CopyRightBlock', CopyRightBlock);
components.set('Diaper-Size-Calculator', DiaperSizeCalculator);
components.set('DiaperCalculator-Calculation', DiaperCalculatorCalculation);
components.set('DiaperCalculator-Layout', DiaperCalculatorLayout);
components.set('DiaperCalculatorForm', DiaperCalculatorForm);
components.set('DiaperSizeCalculator-Layout', DiaperSizeCalculatorLayout);
components.set('Document-API', DocumentAPI);
components.set('Document-Content-Swagger', DocumentContentSwagger);
components.set('DueDate-Calculator', DueDateCalculator);
components.set('DueDate-Layout', DueDateLayout);
components.set('DueDate-SocialShare-Result', DueDateSocialShareResult);
components.set('EyeColor-Layout', EyeColorLayout);
components.set('EyeColor-Predictor', EyeColorPredictor);
components.set('EyeColor-SocialShare-Result', EyeColorSocialShareResult);
components.set('Functional-Document', FunctionalDocument);
components.set('Gender-Layout', GenderLayout);
components.set('Gender-Predictor', GenderPredictor);
components.set('Gender-SocialShare-Result', GenderSocialShareResult);
components.set('GraphQL-ConnectedDemo', GraphQLConnectedDemo);
components.set('GraphQL-IntegratedDemo', GraphQLIntegratedDemo);
components.set('GraphQL-Layout', GraphQLLayout);
components.set('Header-Logo', HeaderLogo);
components.set('HeightPredictor-Calculation', HeightPredictorCalculation);
components.set('HeightPredictor-Layout', HeightPredictorLayout);
components.set('HeightPredictor-SocialShare-Result', HeightPredictorSocialShareResult);
components.set('Home', Home);
components.set('HomeComponentData', HomeComponentData);
components.set('HomeNavigationTile', HomeNavigationTile);
components.set('Loader', Loader);
components.set('MainMenu', MainMenu);
components.set('Ovulation-Calculator', OvulationCalculator);
components.set('Ovulation-Layout', OvulationLayout);
components.set('POC', POC);
components.set('Period-Features', PeriodFeatures);
components.set('Period-Features-New-Version', PeriodFeaturesNewVersion);
components.set('Period-Layout', PeriodLayout);
components.set('Pollen-Tracker', PollenTracker);
components.set('PollenTracker-Layout', PollenTrackerLayout);
components.set('ProductIngredient-Layout', ProductIngredientLayout);
components.set('ProductIngredientData', ProductIngredientData);
components.set('Recipe-Detail-Content', RecipeDetailContent);
components.set('Recipe-Detail-Layout', RecipeDetailLayout);
components.set('Recipe-Layout', RecipeLayout);
components.set('Recipe-SearchResult', RecipeSearchResult);
components.set('RecipeDetailCommon', RecipeDetailCommon);
components.set('RecipeFilterData', RecipeFilterData);
components.set('RecipeFinderData', RecipeFinderData);
components.set('SampleSwaggerDoc', SampleSwaggerDoc);
components.set('SocialShare', SocialShare);
components.set('WeightGain-Calculator', WeightGainCalculator);
components.set('WeightGain-Layout', WeightGainLayout);
components.set('WildcardData', WildcardData);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
